export default __webpack_public_path__ + "static/media/NoOrder.ccae4a13.svg";